"use client"

import { Card, CardContent } from "@/components/ui/card"
import { Download } from "lucide-react"
import Image from "next/image"
import { useTranslations } from "next-intl"

export default function FlyersCatalogsClient() {
  const t = useTranslations("FlyersCatalogs")
  
  const generalCatalog = {
    name: t("generalCatalog"),
    image: "https://www.coverguard-safety.com/media/wysiwyg/Catalogue_g_n_ralNEW.png",
    downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/320bc51fecc423dd893a420b42b9719a/57683b8201f0ab8b50b4caf14e1468e7.pdf",
    viewUrl: "https://www.coverguard-safety.com/flipbook/index/view/bookid/1"
  }

  const categoryCatalogs = [
      {
          name: "Hand protection",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Gants_2023_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/4cf54a3d780b9294815e5f249164f20f/829290cb62bbb9f64f0ad4f5908d39e4.pdf"
      },
      {
          name: "Foot protection",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Chaussures_2023_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/7a50f770e0e910d3beffd653f7c4197e/7ad5815d19e08175963706a717cdb9a1.pdf"
      },
      {
          name: "Seasons",
          image: "https://www.coverguard-safety.com/media/wysiwyg/season.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/7259202cea475e0e98aa076037cc3f15/59c654ca51c68d0043cb63c6795a1ef3.pdf"
      },
      {
          name: "High visibility",
          image: "https://www.coverguard-safety.com/media/wysiwyg/HV2023_EN_2.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/fc73483cfec371c61e8f755f0ed49da4/2dc15abdba74758b6d5878c696d0cedf.pdf"
      },
      {
          name: "Workwear",
          image: "https://www.coverguard-safety.com/media/Capture_d_cran_2022-12-06_153101.jpg",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/9de458965db9c80e1afc5af36a8f93b6/ff4de9230e7adc6512066c1266e40269.pdf"
      },
      {
          name: "Head protection",
          image: "https://www.coverguard-safety.com/media/wysiwyg/t_te.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/f514659f5c754f0cec51ea59a5e826ae/38be51febfbf9ab19859ff8194011ec6.pdf"
      },
      {
          name: "Disposable equipments",
          image: "https://www.coverguard-safety.com/media/wysiwyg/jetable.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/358164500fe22f226f1f07cac73a8288/13948e9ac7e153fd36b48c2620e1394c.pdf"
      },
      {
          name: "Fall protection",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Antichute.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/a23eabd0e013e2ef19cc27099204ea18/d087bbe93f9d46970ae375a477d24656.pdf"
      }
  ];

  const flyers = [
      {
          name: "Food",
          image: "https://www.coverguard-safety.com/media/wysiwyg/FOOD_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/0cf5d42e34cfeb8ae58bf0b5eca73375/170f7a634ef43cab7b431f3115fd966a.pdf"
      },
      {
          name: "Construction",
          image: "https://www.coverguard-safety.com/media/EN_Const_400px.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/846b8bb19a1488bb60ed22ad4af0db5b/dab0e620070c55fdc15e188bfccab971.pdf"
      },
      {
          name: "Mining",
          image: "https://www.coverguard-safety.com/media/EN_Minier_400px.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/45b02e9da70144e563ddb3407d8718ae/c8a31b5a016778937c933c5799daf028.pdf"
      },
      {
          name: "Oil & Gas",
          image: "https://www.coverguard-safety.com/media/EN_O_G_400px.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/a4d4ec4aa3c45731396ed6e65fee40b9/647b3bbade9d44affd43dcaa946976b2.pdf"
      },
      {
          name: "3TP Shoes",
          image: "https://www.coverguard-safety.com/media/EN_3TP_400px.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/1ca4dffd6cb96dfe66f1a044d3bb7cfb/be35d5f7a61990c57b5e00d8df330345.pdf"
      },
      {
          name: "PHOENIX Safety helmet",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Phoenix_2023_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/125af4d20f1ece003e7e5645cb909f2f/1a1c858dd870826e6dcde5cfe11b647a.pdf"
      },
      {
          name: "Access Shoes",
          image: "https://www.coverguard-safety.com/media/FREN_Accessshoes_400px.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/4251c47fdf0b43ddd1e5bf28bc6f3dba/d2175d122344acb5c19b9d43c0707736.pdf"
      },
      {
          name: "Sandals",
          image: "https://www.coverguard-safety.com/media/FREN_Sandales_400px.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/0a4be74a9612071c7992274538563b78/298a2689d7657209d9925c1bc7d24882.pdf"
      },
      {
          name: "DRY PU Safety boots",
          image: "https://www.coverguard-safety.com/media/wysiwyg/DRY_PU_2023_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/c5b86fa907b96e38e377ddfe82802cc6/c12d0793b80cdb7d13c99904c206192e.pdf"
      },
      {
          name: "MECHANICS Gloves",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Mechanics_2023_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/885ca3d99fd35f509a2aa0130e8bf64f/2b723041a8320dddcf524865edc7041c.pdf"
      },
      {
          name: "BLACK STAR Rangers",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Black_Star_2023_EN.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/a0cce36de7a1457b6802255fcec69081/4289cdeb3292ce1c2017a0a4f58dc395.pdf"
      },
      {
          name: "CLAW range",
          image: "https://www.coverguard-safety.com/media/wysiwyg/Claw_2023_EN.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/2e09811007f834b96935dc13e91fabbc/29ce8ae3838a05ec33d94681a6a30c7e.pdf"
      },
      {
          name: "Pelicano",
          image: "https://www.coverguard-safety.com/media/wysiwyg/PELICANO.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/8497c3b1d034ce7aaf059804b5c88db6/44a4559f2b489500934df3d99557b0b7.pdf"
      },
      {
          name: "Multirisks range",
          image: "https://www.coverguard-safety.com/media/wysiwyg/multirisk_en.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/89b3f5223b861dc3a7b8917e293a857a/806ed50dd87aa815a507c88fcb19c916.pdf"
      },
      {
          name: "Anticut gloves",
          image: "https://www.coverguard-safety.com/media/wysiwyg/CUT_EN_1.png",
          downloadUrl: "https://coverguard.hypercomm.fr/data/mediatheque/media/access/original/download/b3aa19fe9dc706a3b4cdaa8ddb37d852/076ce50a12dda4ba93cc12c2964cc2c9.pdf"
      }
  ];

  const handleDownload = (url: string, name: string) => {
    // In a real application, this would trigger the actual download
    //console.log(`Downloading: ${name} from ${url}`)
    window.open(url, '_blank')
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">{t("pageTitle")}</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t("pageDescription")}
          </p>
        </div>

        {/* General Catalog */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold mb-8">{t("generalCatalogTitle")}</h2>
          <div className="flex justify-center">
            <Card
              className="hover:shadow-lg transition-shadow cursor-pointer max-w-sm"
              onClick={() => handleDownload(generalCatalog.downloadUrl, generalCatalog.name)}
            >
              <CardContent className="p-6">
                <div className="relative mb-4 group">
                  <Image
                    src={generalCatalog.image || "/placeholder.svg"}
                    alt={generalCatalog.name}
                    width={600}
                    height={600}
                    className="w-full h-auto rounded-lg"
                  />
                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
                    <Download className="w-12 h-12 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-center">
                  {generalCatalog.name}
                </h3>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Category Catalogs */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold mb-8">{t("categoryCatalogsTitle")}</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {categoryCatalogs.map((catalog, index) => (
              <Card
                key={index}
                className="hover:shadow-lg transition-shadow cursor-pointer"
                onClick={() => handleDownload(catalog.downloadUrl, catalog.name)}
              >
                <CardContent className="p-4">
                  <div className="relative mb-4 group">
                    <Image
                      src={catalog.image || "/placeholder.svg"}
                      alt={catalog.name}
                      width={300}
                      height={425}
                      className="w-full h-auto rounded-lg"
                    />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
                      <Download className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <h3 className="font-semibold text-center">
                    {catalog.name}
                  </h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* Flyers and Leaflets */}
        <section>
          <h2 className="text-3xl font-bold mb-8">{t("flyersTitle")}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {flyers.map((flyer, index) => (
              <Card
                key={index}
                className="hover:shadow-lg transition-shadow cursor-pointer"
                onClick={() => handleDownload(flyer.downloadUrl, flyer.name)}
              >
                <CardContent className="p-3">
                  <div className="relative mb-3 group">
                    <Image
                      src={flyer.image || "/placeholder.svg"}
                      alt={flyer.name}
                      width={170}
                      height={240}
                      className="w-full h-auto rounded-lg"
                    />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
                      <Download className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-center leading-tight">
                    {flyer.name}
                  </h3>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>

        {/* SEO Content */}
        <section className="mt-16 bg-gray-50 p-8 rounded-lg">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold mb-4">
              Каталоги СИЗ и защитной экипировки
            </h2>
            <div className="prose prose-gray max-w-none">
              <p className="text-gray-700 mb-4">
                Скачайте полные каталоги средств индивидуальной защиты (СИЗ) от ведущих 
                производителей. Наши каталоги содержат подробную информацию о защитной 
                экипировке для различных отраслей промышленности.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>Категории СИЗ в каталогах:</strong> защита рук (перчатки), защита ног 
                (обувь), защитная одежда, респираторы, каски, средства защиты глаз и слуха, 
                антипадающая экипировка.
              </p>
              <p className="text-gray-700">
                Все представленные в каталогах СИЗ сертифицированы согласно европейским 
                стандартам и обеспечивают максимальную безопасность на рабочем месте.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
